import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWho() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-33">
          {/* Para quién es */}
          <div data-id="element-34">
            <h3 className="text-2xl font-bold text-stone-900 mb-6 flex items-center" data-id="element-35">
              <span className="bg-emerald-100 text-emerald-800 p-2 rounded-lg mr-3" data-id="element-36">
                <CheckIcon className="h-6 w-6" data-id="element-37" />
              </span>
              Para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-38">
              <li className="flex items-start" data-id="element-39">
                <CheckIcon className="h-5 w-5 text-emerald-600 mr-3 mt-1 flex-shrink-0" data-id="element-40" />
                <span className="text-stone-600" data-id="element-41">
                  Eres una mujer ocupada que necesita estructura clara.
                </span>
              </li>
              <li className="flex items-start" data-id="element-42">
                <CheckIcon className="h-5 w-5 text-emerald-600 mr-3 mt-1 flex-shrink-0" data-id="element-43" />
                <span className="text-stone-600" data-id="element-44">
                  Te sientes estancada y la ropa te aprieta.
                </span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <CheckIcon className="h-5 w-5 text-emerald-600 mr-3 mt-1 flex-shrink-0" data-id="element-46" />
                <span className="text-stone-600" data-id="element-47">
                  Quieres aprender a comer sin depender de dietas de moda.
                </span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <CheckIcon className="h-5 w-5 text-emerald-600 mr-3 mt-1 flex-shrink-0" data-id="element-49" />
                <span className="text-stone-600" data-id="element-50">
                  Buscas un cambio sostenible, no un milagro de 3 días.
                </span>
              </li>
            </ul>
          </div>

          {/* Para quién NO es */}
          <div data-id="element-51">
            <h3 className="text-2xl font-bold text-stone-900 mb-6 flex items-center" data-id="element-52">
              <span className="bg-stone-100 text-stone-600 p-2 rounded-lg mr-3" data-id="element-53">
                <XIcon className="h-6 w-6" data-id="element-54" />
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-55">
              <li className="flex items-start" data-id="element-56">
                <XIcon className="h-5 w-5 text-stone-400 mr-3 mt-1 flex-shrink-0" data-id="element-57" />
                <span className="text-stone-500" data-id="element-58">
                  Buscas una "cura mágica" sin poner de tu parte.
                </span>
              </li>
              <li className="flex items-start" data-id="element-59">
                <XIcon className="h-5 w-5 text-stone-400 mr-3 mt-1 flex-shrink-0" data-id="element-60" />
                <span className="text-stone-500" data-id="element-61">
                  No estás dispuesta a seguir instrucciones por 21 días.
                </span>
              </li>
              <li className="flex items-start" data-id="element-62">
                <XIcon className="h-5 w-5 text-stone-400 mr-3 mt-1 flex-shrink-0" data-id="element-63" />
                <span className="text-stone-500" data-id="element-64">
                  Esperas perder 10 kilos en una semana (eso no es saludable).
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}